export const CONTENT_TYPE_PAGE = "page";
export const CONTENT_TYPE_LANDING_PAGE = "landingPage";
export const CONTENT_TYPE_CAREERS = "careerPosting";
export const CONTENT_TYPE_BLOG = "blog";
export const CONTENT_TYPE_NAVIGATION = "navigation";
export const CONTENT_TYPE_BLOG_TAG = "blogTag";
export const CONTENTFUL_PAGE_LIMIT = 20;
